/**
 * Espelha o `ViewerEngineEnum` do backend. Vai NUMÉRICO no corpo do render: liga
 * com qualquer serializer do .NET, sem depender de conversor de enum por nome.
 * Ausente = Autodesk, que é o que um backend anterior ao nativo entende.
 */
export enum ViewerEngineEnum {
  Autodesk = 0,
  Native = 1,
}
